export const SMART_ANSWER_LABEL_TYPES = {
  SNAPSHOT_BUTTON_ONLY: 'snapshotButtonOnly', // Type to just show just the snapshot button in the label
  SNAPSHOT_BUTTON_AND_ICON: 'snapshotButtonAndIcon', // Type where the label shows BOTH the snapshot button and icons in the other ends of the input width
  NO_SNAPSHOT_BUTTON_OR_ICON: 'noSnapshotButtonOrIcon', // Type where the label DOES NOT show the snapshot button and icons, the Parent component will take care of it
  ICON_ONLY: 'iconOnly', // Type to just show just the icon(s) in the label
};
